import * as Yup from 'yup'

import { FILTER_REPLACEMENT_TEMPLATE_FIELD } from './FilterModalReplacement.constants'

export function getValidationSchema() {
  return Yup.object({
    [FILTER_REPLACEMENT_TEMPLATE_FIELD]: Yup.object().required(true),
  })
}
